export default "__VITE_ASSET__0518f7fb__"